import React from 'react';
import { Card } from 'antd';
import FormInput from 'components/FormInput';
import Value from 'components/Value';
import Title from 'components/Title';
import StatusModal from './StatusModal';
import ModalControllerNV from 'components/ModalControllerNV';
import GetLabel from 'DisplayFramework/components/GetLabel';
export type StatusCardProps = {
  id: string;
  refetchProp: boolean;
};
const StatusCard = ({ id, refetchProp }: StatusCardProps) => {
  return (
    <Card style={{ backgroundColor: '#f7f7f7' }} title={<GetLabel label="status" style={{fontWeight:'bold',paddingLeft:15}}/>}>
      
     
        <table style={{ width: '100%' }}>
          <tbody>
            <tr style={{ backgroundColor: 'rgb(240 242 245)', height: '50px' }}>
              <th align="left">
                <Title level={5} comcode="Type" />
              </th>
              <th align="left">
                <Title level={5} comcode="Status" />
              </th>
              <th align="left">
                <Title level={5} comcode="Date" />
              </th>
            </tr>
            <tr style={{ height: '50px' }}>
              <th align="left">
                <Title level={5} comcode="OverallStatus" />
              </th>
              <td>
                <ModalControllerNV
                  content={({ setVisible, visible }) => (
                    <a onClick={() => setVisible(true)}>
                      <FormInput name="tpstatuslabel" noStyle>
                        <Value />
                      </FormInput>
                    </a>
                  )}
                  modal={({ setVisible, visible }) => (
                    <StatusModal
                      visible={visible}
                      onClose={() => {
                        setVisible(false);
                      }}
                      params={{ tpid: Number(id), type: 'STATUS' }}
                      refetchProp={refetchProp}
                    />
                  )}
                />
              </td>

              <td>
                <FormInput name="tpstatusdate" noStyle>
                  <Value />
                </FormInput>
              </td>
            </tr>
            <tr style={{ backgroundColor: 'rgb(240 242 245)', height: '50px' }}>
              <th align="left">
                <Title level={5} comcode="SALE" />
              </th>
              <td>
                <ModalControllerNV
                  content={({ setVisible, visible }) => (
                    <a onClick={() => setVisible(true)}>
                      <FormInput name="tpsalestatuslabel" noStyle>
                        <Value />
                      </FormInput>
                    </a>
                  )}
                  modal={({ setVisible, visible }) => (
                    <StatusModal
                      visible={visible}
                      onClose={() => {
                        setVisible(false);
                      }}
                      params={{ tpid: Number(id), type: 'SALE' }}
                      refetchProp={refetchProp}
                    />
                  )}
                />
              </td>

              <td>
                <FormInput name="tpsalestatusdate" noStyle>
                  <Value />
                </FormInput>
              </td>
            </tr>
            <tr style={{ height: '50px' }}>
              <th align="left">
                <Title level={5} comcode="RISK" />
              </th>
              <td>
                <ModalControllerNV
                  content={({ setVisible, visible }) => (
                    <a onClick={() => setVisible(true)}>
                      <FormInput name="tpriskstatuslabel" noStyle>
                        <Value />
                      </FormInput>
                    </a>
                  )}
                  modal={({ setVisible, visible }) => (
                    <StatusModal
                      visible={visible}
                      onClose={() => {
                        setVisible(false);
                      }}
                      params={{ tpid: Number(id), type: 'RISK' }}
                      refetchProp={refetchProp}
                    />
                  )}
                />
              </td>

              <td>
                <FormInput name="tpriskstatusdate" noStyle>
                  <Value />
                </FormInput>
              </td>
            </tr>
            <tr style={{ backgroundColor: 'rgb(240 242 245)', height: '50px' }}>
              <th align="left">
                <Title level={5} comcode="KYC" />
              </th>
              <td>
                <ModalControllerNV
                  content={({ setVisible, visible }) => (
                    <a onClick={() => setVisible(true)}>
                      <FormInput name="tpkycstatuslabel" noStyle>
                        <Value />
                      </FormInput>
                    </a>
                  )}
                  modal={({ setVisible, visible }) => (
                    <StatusModal
                      visible={visible}
                      onClose={() => {
                        setVisible(false);
                      }}
                      params={{ tpid: Number(id), type: 'KYC' }}
                      refetchProp={refetchProp}
                    />
                  )}
                />
              </td>

              <td>
                <FormInput name="tpkycdate" noStyle>
                  <Value />
                </FormInput>
              </td>
            </tr>

            <tr style={{ backgroundColor: '#fff', height: '50px' }}>
              <th align="left">
                <Title level={5} comcode="class" />
              </th>
              <td>
                <ModalControllerNV
                  content={({ setVisible, visible }) => (
                    <a onClick={() => setVisible(true)}>
                      <FormInput name="tpclasslabel" noStyle>
                        <Value />
                      </FormInput>
                    </a>
                  )}
                  modal={({ setVisible, visible }) => (
                    <StatusModal
                      visible={visible}
                      onClose={() => {
                        setVisible(false);
                      }}
                      params={{ tpid: Number(id), type: 'SAIN' }}
                      refetchProp={false}
                    />
                  )}
                />
              </td>

              <td>
                <FormInput name="tpclassdate" noStyle>
                  <Value />
                </FormInput>
              </td>
            </tr>
          </tbody>
        </table>
      </Card>
   
  );
};

export default StatusCard;
